import { getPageNumbersWithEmailQuestion } from './components';

/**
 * getPagesTriggeringPartialSubmission
 *
 * Returns the page numbers which can show a partial submission legal statement as well as triggering partial submission when CTA is clicked.
 *
 * We currently only include partial capture for specific forms. Partial capture will only be triggered when there are no live or 7 day supplier matches.
 *
 */
export const getPagesTriggeringPartialSubmission = (
  components,
  enabledPartialSubmission,
  countryCode
) => {
  return enabledPartialSubmission && countryCode === 'US'
    ? getPageNumbersWithEmailQuestion(components)
    : [];
};

/**
 * shouldPageTriggerPartialSubmission
 *
 * Returns true if the page should trigger a partial submission.
 * This is based on the page number and the match level.
 *
 * When a page will trigger a partial submission, an appropriate legal statement will be shown and the partial submission will be triggered when the CTA is clicked.
 */
export const shouldPageTriggerPartialSubmission = (
  page,
  partialSubmissionPages
) => {
  return partialSubmissionPages.includes(page);
};
